import type { DataChartConfig } from '../serviceExecutionApi';

export function DataAnalysisChartFields({ columns, charts, onChange }: {
  columns: string[];
  charts: DataChartConfig[];
  onChange: (charts: DataChartConfig[]) => void;
}) {
  const update = (index: number, patch: Partial<DataChartConfig>) => {
    onChange(charts.map((chart, position) => position === index ? { ...chart, ...patch } : chart));
  };
  return <fieldset>
    <legend>Графики</legend>
    <p>До четырёх графиков по выбранным числовым столбцам. Используются все валидные наблюдения; исключение неполных значений требует соответствующей политики выше.</p>
    {charts.map((chart, index) => <fieldset key={index}>
      <legend>График {index + 1}</legend>
      <label>Вид графика {index + 1}
        <select value={chart.kind} onChange={(event) => update(index, {
          kind: event.target.value as DataChartConfig['kind'],
          y: event.target.value === 'SCATTER' ? (columns.find((column) => column !== chart.x) || '') : '',
        })}>
          <option value="HISTOGRAM">Гистограмма распределения</option>
          <option value="SCATTER" disabled={columns.length < 2}>Диаграмма рассеяния</option>
        </select>
      </label>
      <label>Столбец X графика {index + 1}
        <select required value={chart.x} onChange={(event) => update(index, {
          x: event.target.value,
          y: chart.kind === 'SCATTER' && chart.y === event.target.value
            ? (columns.find((column) => column !== event.target.value) || '') : chart.y,
        })}>
          <option value="">Выберите столбец</option>
          {columns.map((column) => <option key={column} value={column}>{column}</option>)}
        </select>
      </label>
      {chart.kind === 'SCATTER' ? <label>Столбец Y графика {index + 1}
        <select required value={chart.y} onChange={(event) => update(index, { y: event.target.value })}>
          <option value="">Выберите столбец</option>
          {columns.filter((column) => column !== chart.x).map((column) => <option key={column} value={column}>{column}</option>)}
        </select>
      </label> : <label>Число интервалов графика {index + 1}
        <input type="number" required min={5} max={50} step={1} value={chart.bins}
          onChange={(event) => update(index, { bins: Number(event.target.value) })} />
      </label>}
      <button type="button" className="owner-uat-btn" onClick={() => onChange(charts.filter((_, position) => position !== index))}>
        Удалить график {index + 1}
      </button>
    </fieldset>)}
    <button type="button" className="owner-uat-btn primary" disabled={!columns.length || charts.length >= 4}
      onClick={() => onChange([...charts, { kind: 'HISTOGRAM', x: columns[0], y: '', bins: 10 }])}>
      Добавить график
    </button>
  </fieldset>;
}
